// import Oidc from 'oidc-client';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { useEffect } from 'react';
// import LoaderOverlay from 'components/LoaderOverlay/LoaderOverlay';

// function AuthenticationCallback(props: AuthenticationCallbackProps) {
//     const { onAuthorizedEvent } = props;
//     const identityManager = new Oidc.UserManager({ ...props.config, response_mode: 'query' });
//     const navigate = useNavigate();

//     useEffect(() => {
//         identityManager
//             .signinRedirectCallback()
//             .then(() => {
//                 identityManager.getUser().then((user) => {
//                     if (user) {
//                         axios.defaults.headers.common = {
//                             Authorization: `Bearer ${user.access_token}`,
//                         };
//                         identityManager.startSilentRenew();
//                         onAuthorizedEvent();
//                     }
//                 });
//                 navigate('/', { replace: true });
//             })
//             .catch((error) => console.log(error));
//     }, [navigate, onAuthorizedEvent]);

//     return <LoaderOverlay isLoading={true} />;
// }

// export default AuthenticationCallback;

// type AuthenticationCallbackProps = {
//     onAuthorizedEvent: () => void;
//     config: Oidc.UserManagerSettings
// };


// src/AuthenticationCallback.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "authService";
import LoaderOverlay from "components/LoaderOverlay/LoaderOverlay";

function AuthenticationCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    msalInstance.handleRedirectPromise().then(() => navigate("/", { replace: true }));
  }, [navigate]);

  return <LoaderOverlay isLoading={true} />;
}

export default AuthenticationCallback;
